import type {Specie} from '../../../generated/types';
import {CreatureTypes, sizesToString} from '../../../components/enums';
import {humanEnumeration, uppercaseFirstLetter, wordByCount} from '../../../components/utils';
import {composeDescription} from '../../../lib/seo/text';
import type {OgCardData} from '../../../lib/seo/site';

function typeText(specie: Specie): string {
	return uppercaseFirstLetter(CreatureTypes[specie.type] || specie.type || '');
}

function sizesText(specie: Specie): string {
	return humanEnumeration(
		(specie.sizes || []).map((size) => sizesToString(size.category)),
		'или',
	);
}

function speedText(specie: Specie): string {
	return specie.speed ? wordByCount(specie.speed, ['фут', 'фута', 'футов'], true) : '';
}

/** «Вид Эльф: тип существа Гуманоид, размер Средний, скорость 30 футов. …» */
export function specieDescription(specie: Specie): string {
	const type = typeText(specie);
	const sizes = sizesText(specie);
	const speed = speedText(specie);
	const details = [type && `тип существа ${type}`, sizes && `размер ${sizes}`, speed && `скорость ${speed}`].filter(
		Boolean,
	);
	return composeDescription(`Вид ${specie.title}${details.length ? `: ${details.join(', ')}` : ''}.`, specie.description);
}

export function specieOgCard(specie: Specie): OgCardData {
	const speed = speedText(specie);
	return {
		label: 'Вид',
		title: specie.title,
		originalTitle: specie.originalTitle,
		subtitle: [typeText(specie), sizesText(specie), speed && `скорость ${speed}`].filter(Boolean).join(' · '),
	};
}
